import {
  ArrowBackRounded,
  ControlPointOutlined,
  EditRounded,
  FileCopy,
  KeyboardArrowDownOutlined,
} from "@mui/icons-material";
import {
  Box,
  Breadcrumbs,
  Button,
  IconButton,
  Menu,
  MenuItem,
  Modal,
  Paper,
  Slide,
  Tooltip,
  AlertTitle,
  Typography,
  useMediaQuery,
  useTheme,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { styled, alpha } from "@mui/material/styles";
import AddCandidate from "../../candidatesPage/AddCandidate";
import FileUploader from "../ResumeSelection/ResumesUpload";
import { appSelector } from "../../redux/selector";
import { useDispatch, useSelector } from "react-redux";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { myCandidatesSelector } from "../redux/selector";
import { selectedResume, selectedTabViewAction } from "../redux/action";

const TopBar = ({
  onSubmit,
  Step1HandlerTopBar,
  setCandidatesRefresh,
  resumeAddToSendVendorStep,
  goToStep2,
  resume,
}) => {
  const dispatch = useDispatch();
  const { tabView, jobDetails } = useSelector(myCandidatesSelector);

  // State for modal and menu controls
  const [open, setOpen] = useState(false);
  const [addCandidateFormOpen, setAddCandidateFormOpen] = useState(false);
  const addCandidateRef = useRef(null);
  const [parseAddCandidateFormOpen, setParseAddCandidateFormOpen] = useState(false);
  const parseAddCandidateRef = useRef(null);
  const [anchorElAddCandidateMenu, setAnchorElAddCandidateMenu] = useState(null);
  const [openAddCanOrRes, setOpenAddCanOrRes] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [openAddCandidateMenu, setOpenAddCandidateMenu] = useState(false);

  const handleOpenSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarOpen(false);
  };

  // Handle navigation with resume selection
  const handleNavigateToSubmission = () => {
    if (!resume?.filename) {
      setSnackbarMessage("Please select a resume first");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      return;
    }

    // Set resume in store before navigation
    dispatch(selectedResume(resume));

    // Update step if handler exists
    if (typeof Step1HandlerTopBar === 'function') {
      Step1HandlerTopBar(false);
    }

    // Navigate to submission view
    dispatch(selectedTabViewAction("Submission"));
  };

  const handleOpen = () => {
    if (resume?.filename) {
      setOpen(true);
    }
  };

  const handleClose = () => setOpen(false);

  const handleSubmit = () => {
    if (!resume?.filename) {
      setSnackbarMessage("Please select a resume first");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      return;
    }

    try {
      // First dispatch resume selection to store
      dispatch(selectedResume(resume));

      // Close the modal
      handleClose();

      // Show success message
      setSnackbarMessage("Successfully selected resume for submission");
      setSnackbarSeverity("success");
      setSnackbarOpen(true);

      // Delay navigation to allow snackbar to be visible
      setTimeout(() => {
        // If Step1HandlerTopBar exists, call it to update step
        if (typeof Step1HandlerTopBar === 'function') {
          Step1HandlerTopBar(false);
        }

        // Call parent submission handler if exists
        if (typeof onSubmit === 'function') {
          onSubmit();
        }

        // Navigate to submission view last
        dispatch(selectedTabViewAction("Submission"));
      }, 1000); // 1 second delay

    } catch (error) {
      console.error('Navigation error:', error);
      setSnackbarMessage("Error navigating to submission flow");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  };


  useEffect(() => {
    if (goToStep2) {
      Step1HandlerTopBar(false);
    }
  }, [goToStep2]);
  const addCandidateButtonHandler = () => {
    setAddCandidateFormOpen(true);
  };

  const handleCloseAddCandidateMenu = () => {
    setAnchorElAddCandidateMenu(null);
  };

  const parseAddCandidate = () => {
    setParseAddCandidateFormOpen(true);
    setOpenAddCanOrRes("add_candidates");
  };

  const addResumeHandler = () => {
    setParseAddCandidateFormOpen(true);
    setOpenAddCanOrRes("add_resumes");
  };

  const candidatesRefreshHandler = (isRefresh) => {
    setCandidatesRefresh(isRefresh);
  };

  const closeResumeParserModal = (isClose) => {
    setParseAddCandidateFormOpen(!isClose);
    setCandidatesRefresh(isClose);
  };

  const popupsHandler = (msg, severity) => {
    if (msg) {
      handleOpenSnackbar(msg, severity);
    }
  };

  return (
    <Paper elevation={2} sx={topBarStyles}>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        {tabView && tabView === "Resume Selection" && (
          <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <Tooltip followCursor title="Go To Submission Flow">
              <IconButton onClick={handleNavigateToSubmission}>
                <ArrowBackRounded />
              </IconButton>
            </Tooltip>
            <Button
              variant="contained"
              disableElevation
              startIcon={<ControlPointOutlined />}
              onClick={addResumeHandler}
              sx={{
                textTransform: "capitalize",
                padding: "4px 12px",

                fontWeight: 400,
                height: "32.5px",
                bgcolor: "rgba(64, 104, 130, 0.9)",
                "&:hover": {
                  bgcolor: "#406882",
                },
              }}
            >
              Add Resume
            </Button>

            <Typography
              paragraph
              sx={{ m: 0, fontSize: "18px", fontWeight: 800, color: "#4D5562" }}
            >
              Step 1 : Accept Job Manually - Resume File Selection
            </Typography>
          </Box>
        )}
        <Modal
          open={addCandidateFormOpen}
          onClose={() => {
            setAddCandidateFormOpen(false);
          }}
        >
          <Slide
            direction="left"
            in={addCandidateFormOpen}
            container={addCandidateRef.current}
            mountOnEnter
            unmountOnExit
            timeout={{ enter: 1000, exit: 1000 }}
            style={{
              transitionTimingFunction: "cubic-bezier(0.68, -0.55, 0.27, 1.55)",
            }}
          >
            <Paper
              elevation={4}
              style={{
                transform: "scale(1)",
                transition: "transform 0.5s ease-in-out",

                ...modalStyles,
              }}
            >
              <AddCandidate setAddCandidateFormOpen={setAddCandidateFormOpen} />
            </Paper>
          </Slide>
        </Modal>
        <StyledMenu
          id="demo-customized-menu"
          MenuListProps={{
            "aria-labelledby": "demo-customized-button",
          }}
          anchorEl={anchorElAddCandidateMenu}
          open={openAddCandidateMenu}
          onClose={handleCloseAddCandidateMenu}
        >
          <MenuItem
            onClick={() => {
              handleCloseAddCandidateMenu();
              addCandidateButtonHandler();
            }}
            disableRipple
          >
            <EditRounded />
            Manually
          </MenuItem>
          <MenuItem
            onClick={() => {
              handleCloseAddCandidateMenu();
              parseAddCandidate();
            }}
            disableRipple
          >
            <FileCopy />
            Parse
          </MenuItem>
        </StyledMenu>
        <Box sx={{ flexGrow: 1 }} />

        {/* <Box sx={{ display: jobDetails ? "block" : "none", mr: "10px" }}>
          <Breadcrumbs separator="-" aria-label="breadcrumb">
            <p
              style={{
                margin: 0,
                fontWeight: 600,
                fontSize: isDesktopLarge ? "1.0rem" : "0.85rem",
              }}
            >
              #{jobDetails?.id}
            </p>
            <p
              style={{
                margin: 0,
                fontWeight: 600,
                fontSize: isDesktopLarge ? "1.0rem" : "0.85rem",

                minWidth: isDesktopLarge ? "150px" : "100px",
                maxWidth: isDesktopLarge ? "250px" : "150px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {jobDetails?.jobtitle}
            </p>
            {jobDetails?.experience && (
              <p
                style={{
                  margin: 0,
                  fontWeight: 600,
                  fontSize: isDesktopLarge ? "1.0rem" : "0.85rem",
                }}
              >
                {jobDetails?.experience}
              </p>
            )}
            <p
              style={{
                margin: 0,
                fontWeight: 600,
                fontSize: isDesktopLarge ? "1.0rem" : "0.85rem",
              }}
            >
              {jobDetails?.is_remote === 1
                ? "Remote"
                : jobDetails?.location !== null &&
                  jobDetails?.location !== undefined
                ? jobDetails?.location
                : "Remote"}
            </p>
          </Breadcrumbs>
        </Box> */}

        <Button
          sx={{
            ...jobViewButtonStyles,
            ...btnStyles,
            display:
              tabView && tabView === "Resume Selection" ? "block" : "none",
          }}
          onClick={handleOpen}
        >
          Continue
        </Button>
      </Box>
      {/* Modal for file upload */}
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>
          <AlertTitle>Info</AlertTitle>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" sx={{ mb: 2 }}>
            Selected File: {resume?.filename}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary">
            Cancel
          </Button>
          <Button onClick={handleSubmit} variant="contained" color="primary">
            Submit
          </Button>
        </DialogActions>
      </Dialog>
      <Modal
        open={parseAddCandidateFormOpen}
        onClose={() => {
          setParseAddCandidateFormOpen(false);
        }}
      >
        <Slide
          direction="left"
          in={parseAddCandidateFormOpen}
          container={parseAddCandidateRef.current}
          mountOnEnter
          unmountOnExit
          timeout={{ enter: 1000, exit: 1000 }}
        >
          <Paper
            elevation={4}
            style={{
              transition: "opacity 2s ease-in-out",
              ...modalParseStyles,
            }}
          >
            <FileUploader
              check={openAddCanOrRes}
              candidatesRefreshHandler={candidatesRefreshHandler}
              closeResumeParserModal={closeResumeParserModal}
              popupsHandler={popupsHandler}
            />
          </Paper>
        </Slide>
      </Modal>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MuiAlert onClose={handleSnackbarClose} severity={snackbarSeverity}>
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </Paper>
  );
};

export default TopBar;

const btnStyles = {
  fontSize: "12px",
  borderRadius: "20px",
  mr: 2,
  width: 120,
  pt: "2px",
  pb: "2px",
  textTransform: "capitalize",
};

const jobViewButtonStyles = {
  backgroundImage: true
    ? "linear-gradient(360deg, #406882 0%, #518aa7 50%, #6d9ec6 100%)"
    : "#fff",
  color: true ? "#fff" : "#406882",
  border: true ? "none" : "1px solid #406882",
  ml: 2,

  "&:hover": {
    backgroundImage:
      "linear-gradient(360deg, #406882 0%, #518aa7 50%, #6d9ec6 100%)",
    color: "#fff",
    border: "none",
  },
};

const topBarStyles = {
  padding: "4px",
  borderRadius: "4px",
  margin: "5px 5px 5px 5px",
  border: "none",
};

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 120,
    color:
      theme.palette.mode === "light"
        ? "rgb(55, 65, 81)"
        : theme.palette.grey[300],
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    "& .MuiMenuItem-root": {
      "& .MuiSvgIcon-root": {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      "&:active": {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity
        ),
      },
    },
  },
}));

const modalStyles = {
  position: "absolute",
  top: "5%",
  left: "10%",
  transform: "translate(-50%, -50%)",
  width: "80%",
  bgcolor: "background.paper",
  border: "none",
  boxShadow: 24,
  p: 4,
  borderRadius: "8px",
  height: "80vh",
  overflow: "scroll",
};

const modalParseStyles = {
  position: "absolute",
  top: "20%",
  left: "35%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  maxHeight: "70vh",
  overflow: "scroll",
};
